import { isObject } from "@pineapplelab/util";
import { FBase } from "./FBase";
import { FavoriteTypeEnum } from "../enums/favoriteType.enum";

export class Favorite extends FBase {

	type: FavoriteTypeEnum = null;
	categoryName: string = null;
	courseName: string = null;
	courseNameLowercase: string = null;
	categoryId: string = null;
	courseId: string = null;
	chapterName: string = null;
	chapterNameLowercase: string = null;
	chapterIndex: number = null;
	totalChapters: number = null;
	duration: number = null;
	courseImage: string = null;
	video: boolean = null;
	quiz: boolean = null;

	constructor(json?: { [key: string]: any }) {
		super();
		if (isObject(json)) {
			this.fromJson(json);
		}
	}
}
export namespace Favorite {

	export const PATH = 'favorites';

}
